import React from "react";
import { withAuthenticationRequired, withAuth0 } from "@auth0/auth0-react";
import Loader from "../../components/Loader";

class Default extends React.Component {

  constructor({ match, ...props }) {
    super(...arguments);
  }
  async componentDidMount() {
    const { user, isAuthenticated } = this.props.auth0;
    if (isAuthenticated) {
      localStorage.removeItem("pdUserRole");
      if (user['https://propertydek.com/roles'].indexOf('Security') > -1) {
        localStorage.setItem("pdUserRole", 'Security');
        //this.props.history.push('/security/journal/list');
      } else if (user['https://propertydek.com/roles'].indexOf('Technician') > -1) {
        localStorage.setItem("pdUserRole", 'Technician');
        //this.props.history.push('/cases/maintenance-request');
      } else {
        localStorage.setItem("pdUserRole", 'Other');
        // this.props.history.push('/dashboard');
      }

      let redirectUrl = '/dashboard';
      if (user['https://propertydek.com/permissions'].indexOf('journal:read') > -1) {
        redirectUrl = '/security/journal/list';
      }
      if (user['https://propertydek.com/permissions'].indexOf('vehicle:read') > -1) {
        redirectUrl = '/security/vehicle/list';
      }
      if (user['https://propertydek.com/permissions'].indexOf('income:read') > -1) {
        redirectUrl = '/income/all-income';
      }
      if (user['https://propertydek.com/permissions'].indexOf('task-checklist:read') > -1) {
        redirectUrl = '/cases/task-list';
      } else if (user['https://propertydek.com/permissions'].indexOf('task:read') > -1) {
        redirectUrl = '/cases/tasks';
      }
      if (user['https://propertydek.com/permissions'].indexOf('request:read') > -1) {
        redirectUrl = '/cases/maintenance-request';
      }
      if (user['https://propertydek.com/permissions'].indexOf('device:read') > -1) {
        redirectUrl = '/smart-devices/list';
      }
      if (user['https://propertydek.com/permissions'].indexOf('prospect:read') > -1) {
        redirectUrl = '/people/prospects';
      } else if (user['https://propertydek.com/permissions'].indexOf('tenant:read') > -1) {
        redirectUrl = '/people/tenants';
      }
      if (user['https://propertydek.com/permissions'].indexOf('property:read') > -1) {
        redirectUrl = '/properties/list';
      }
      if (user['https://propertydek.com/permissions'].indexOf('dashboard:read') > -1) {
        redirectUrl = '/dashboard';
      }

      this.props.history.push(redirectUrl);
    }
  }

  render() {

    return (
      <React.Fragment>
        <Loader />
      </React.Fragment>
    );
  }

}
export default withAuthenticationRequired(withAuth0(Default), {
  onRedirecting: () => <Loader />,
});